import { reactive } from "vue";

export const videoStore = reactive({
  play: false,
  url: ''
})

export const playVideoTransition = () => {
  videoStore.play = true;
}

export const setFinalVideo = (video: string) => {
  videoStore.url = video;
}